import React from 'react';
import { images } from '../data/content';
export function Hero() {
  return <section className="px-6 pb-4 pt-10" data-id="element-36" data-mp="ejwfyzd2ht1i">
      <h1 className="text-center font-display text-[29px] font-semibold leading-[1.28] tracking-[-0.015em] text-ink-900" data-id="element-37" data-mp="ej4n3wauu9ex">
        With just <span className="text-ink-700" data-id="element-38" data-mp="9ipd9eps7k1p">10 minutes a day</span>, your child{' '}
        <span className="text-forest-600" data-id="element-39" data-mp="4na06ozlls6c">puts the phone down</span> and starts creating with their
        own hands with <span className="accent-underline text-gold-500" data-id="element-40" data-mp="127ef5fynvtei">+365 clever projects</span>.
      </h1>

      <div className="mt-8" data-id="element-41" data-mp="xb5whsl99i2l">
        <img src={images.heroBox} alt="Open Little Engineer Megakit box filled with cardboard projects, idea cards and building materials" className="mx-auto w-full max-w-[420px]" loading="eager" data-id="element-42" data-mp="sbb57nxkiqh0" />
      </div>
    </section>;
}